<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px" />
          <div class="row mb-2">
            <div class="col-sm-3">
              <span class="mt-1 d-block">Total : {{ income_from_trade_trainees.total }}</span>
            </div>
            <div class="col-sm-12">
              <div v-if="flag">
                <download-excel class="btn btn-light float-right" :fetch="fetchData" :fields="excel_fileds"
                  :meta="json_meta" worksheet="Trainee income from trade" name="trainee-inceome-from-trade.xls"
                  :before-finish="hideSpinner">
                  <span v-if="spinner" class="spinner-border spinner-border-sm text-muted "
                    style="margin-bottom : 2px;"></span>
                  Download Excel
                </download-excel>

                <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                  <div v-if="loading" class="spinner-border spinner-border-sm text-muted" style="margin-bottom : 2px;">
                  </div>
                  Download PDF
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Form No</th>
                  <th>Trainee Name</th>
                  <th>Mouza</th>
                  <th class="text-right">Income From Training Trade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(followup, index) in income_from_trade_trainees.data" :key="index">
                  <td>{{ followup.trainee_id }}</td>
                  <td>{{ followup.form_no }}</td>
                  <td>
                    <router-link :to="{ name: 'traineeView', params: { trainee_id: followup.trainee_id } }" tag="a"
                      target="_blank">{{ followup.rep_name ? followup.rep_name : followup.name }}
                    </router-link>
                  </td>
                  <td>{{ followup.mouza }}</td>
                  <td class="text-right">{{ followup.income_from_training_trade.toLocaleString('en-BD') }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="float-right">
            <pagination :data="income_from_trade_trainees" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>

        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  page: {
    title: "Income From Trade Info",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      loading: false,
      spinner: false,
      title: "Income From Trade",
      dataCount: 0,
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Income From Trade",
          active: true
        }
      ],
      income_from_trade_trainees: {},
      excel_fileds: {
        'Followup form no': 'form_no',
        'Trainee name': {
          callback: (value) => {
            if (value.trainee)
              return value.trainee.rep_name ? value.trainee.rep_name : value.trainee.name
            else
              return '';
          }
        },
        'Mouza': 'trainee.mouza.desc',
        'Income from trade': 'income_from_training_trade',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      flag: false,
    };
  },

  mounted() {
    this.getIncomeFromTradeTrainee();
    this.getResults();
  },
  methods: {
    async dowonloadPdf() {
      this.loading = true
      let response = await http.get("api/trainee/iga/income-from-trade/list/download")
      // console.log(response.data)
      var data = []
      try {
        response.data.forEach(function (item) {
          if (item.trainee) {
            data.push([
              item.form_no,
              item.trainee.rep_name ? item.trainee.rep_name : item.trainee.name,
              item.trainee.mouza.desc,
              item.income_from_training_trade
            ])
          }
        })
      }
      catch (e) {
        console.log(e.message)
      }

      const doc = new jsPDF()
      autoTable(doc, {
        head: [['Form No', 'Trainee Name', 'Mouza', 'Income From Training Trade']],
        body: data,
      })
      doc.save('iga-income-from-trade-report.pdf')
      this.loading = false
    },
    getIncomeFromTradeTrainee() {
      http.get("api/trainee/iga/income-from-trade/list").then(response => {
        if (!response.error) {
          this.flag = true;
          this.income_from_trade_trainees = response.data;
        }
      });
    },
    getResults(page = 1) {
      http.get("api/trainee/iga/income-from-trade/list?page=" + page).then(response => {
        if (!response.error) {
          this.flag = true;
          this.income_from_trade_trainees = response.data;
        }
      });
    },
    async fetchData() {
      this.spinner = true
      let response = await http.get("api/trainee/iga/income-from-trade/list/download")
      return response.data
    },
    hideSpinner() {
      this.spinner = false
    }
  },
};
</script>
